(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["music-sidebar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const mobileBreakpoint = window.matchMedia('(max-width: 767px)');
    const sidebarMenus = document.querySelectorAll('.music-sidebar-menu');

    function setSectionState(menu, button, expanded) {
      const section = button.getAttribute('data-music-sidebar-section');
      const content = menu.querySelector('[data-music-sidebar-content="' + section + '"]');

      if (!content) return;

      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      content.classList.toggle('collapsed', !expanded);
    }

    function setDefaultStates(menu) {
      const toggleButtons = menu.querySelectorAll('.music-sidebar-section-toggle');

      toggleButtons.forEach(function(button) {
        setSectionState(menu, button, !mobileBreakpoint.matches);
      });
    }

    sidebarMenus.forEach(function(menu) {
      const toggleButtons = menu.querySelectorAll('.music-sidebar-section-toggle');

      toggleButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          setSectionState(menu, button, !isExpanded);
        });
      });

      setDefaultStates(menu);
      mobileBreakpoint.addEventListener('change', function() {
        setDefaultStates(menu);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
